import React, { Component } from 'react';
import './NavBar.css';
import logo from 'assets/logo-new.svg';
import history from '../../history';
import AccountMenu from '../accountMenu/AccountMenu';
import classNames from 'classnames';
import models from "../../model/models";
export default class NavBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			url: window.location.pathname,
			hideVoteForLogrx:Boolean(localStorage.hideVoteForLogrx)
		};
	}

	componentDidMount = () => {
		history.onChange((url) => {
			this.setState({ url });
		});
    this.userGroupSubId = models.user_group.onChange(this.updateUserGroup)

		window.addEventListener('keyup', (event) => {
		if (event.keyCode !== 13) {
			return;
		}
			this.OnEnterPress();
		});
	};

	componentWillUnmount() {
		models.user_group.unsubscribe(this.userGroupSubId)
		window.removeEventListener('keyup', (event) => {
			if (event.keyCode !== 13) {
				return;
			}
			this.OnEnterPress();
		});
	}

  updateUserGroup = () => {
    this.setState({userGroup:models.user_group.obj()})
  };

	isActiveTab = (routes, exact) => {
		for (let i in routes){
		  if(this._isActive(routes[i], exact)){
				return true;
			}
		}
		return false;
	}
	_isActive = (route, exact) => {
		if (exact) {
			if (this.state.url === route) {
				return true;
			}
			return false;
		} else if (this.state.url.indexOf(route) === 0) {
			return true;
		}
		return false;
	};

	OnEnterPress = () => {
		console.log(localStorage.token);
		if(document.activeElement.onClick !== null){
			document.activeElement.click()
		}
	}

	canSelectWithTab = () => {
		// let popupOpen = this.checkPopupOpen();
		// if(popupOpen) return -1;
		if(!localStorage.token) return -1;
		else if(localStorage.token){
			return 0;
		}
		else{
			return -1;
		}
	}

	// checkPopupOpen = () => {
	// 	var popupArray = PopupController.state.components;
	// 	var popupOpen;
	// 	for(var i = 0; i < popupArray.length; i++){
	// 		if(popupArray[i].show = true){
	// 			popupOpen = true;
	// 		}
	// 	}
	// 	return popupOpen;
	// }

	render() {
		return (
			<div role="banner" className="g-nav-bar">
				<img tabIndex={this.canSelectWithTab()}
					onClick={() => {
						history.navigate('/');
					}}
					src={logo}
					alt="Company Logo"
				/>
				<div
					tabIndex={this.canSelectWithTab()}
					className={classNames({ active: this.isActiveTab(['/'], true) })}
					onClick={() => {
						history.navigate('/');
					}}
				>
					Dashboard
				</div>
				<div
					tabIndex={this.canSelectWithTab()}
					className={classNames({ active: this.isActiveTab(['/drugs', '/drug/']) })}
					onClick={() => {
						history.navigate('/drugs');
					}}
				>
					Drugs
				</div>
				<div
					tabIndex={this.canSelectWithTab()}
					className={classNames({ active: this.isActiveTab(['/users', '/user']) })}
					onClick={() => {
						history.navigate('/users');
					}}
				>
					Users
				</div>
				<div
					tabIndex={this.canSelectWithTab()}
					className={classNames({ active: this.isActiveTab(['/units', '/unit', '/drug_box']) })}
					onClick={() => {
						history.navigate('/units');
					}}
				>
					Units & Boxes
				</div>
				{/*<div>Units</div>*/}
				<div
					tabIndex={this.canSelectWithTab()}
					className={classNames({ active: this.isActiveTab(['/reports', '/forms']) })}
					onClick={() => {
						history.navigate('/reports/recommended');
					}}
				>
					Reports
				</div>
				<div
					tabIndex={this.canSelectWithTab()}
					className={classNames({ active: this.isActiveTab(['/activity']) })}
					onClick={() => {
						history.navigate('/activity');
					}}
				>
					Activity
				</div>
        {Boolean(this.state.userGroup && this.state.userGroup.has_overdue_invoice) && <div className={'has-overdue-invoice'}>Your invoice is now more than 30 days past due. Please contact LogRx administrators at info@logrx.com</div>}
				<AccountMenu />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/navBar/NavBar.jsx